import { jsxs as i, jsx as o, Fragment as A } from "react/jsx-runtime";
import { c as r } from "../../../../clsx-OuTLNxxd.js";
import { u as D } from "../../../../downshift.esm-B5WCuwFD.js";
import { useState as P, useEffect as T, useMemo as G } from "react";
import { I as m } from "../../../../icon-B72I4fRl.js";
import "../../icon/iconsList.js";
import { AlternativeAction as J } from "./alternativeAction/alternativeAction.js";
const K = "_disabled_10236_76", M = "_hidden_10236_139", Q = "_highlight_10236_155", e = {
  "autocomplete-container": "_autocomplete-container_10236_29",
  "full-width": "_full-width_10236_33",
  "input-container": "_input-container_10236_43",
  "has-error": "_has-error_10236_52",
  "label-helper-text": "_label-helper-text_10236_55",
  "input-block": "_input-block_10236_60",
  disabled: K,
  "error-text": "_error-text_10236_118",
  "suggestions-container": "_suggestions-container_10236_127",
  hidden: M,
  "has-alternative-action": "_has-alternative-action_10236_142",
  "alternative-action-container": "_alternative-action-container_10236_155",
  highlight: Q,
  "item-block": "_item-block_10236_158",
  "no-suggestion": "_no-suggestion_10236_169",
  "has-href": "_has-href_10236_180",
  "alternative-action-container-wrapper": "_alternative-action-container-wrapper_10236_183"
}, ee = ({
  onChange: V,
  onSelect: y,
  suggestions: a = [],
  inputValue: l,
  noSuggestionText: z,
  placeholder: _,
  label: u,
  labelHelperContent: g,
  inputIcon: f,
  itemsIcon: h,
  disabled: b = !1,
  hasError: p = !1,
  errorText: C,
  alternativeAction: n,
  isFullWidth: j = !1,
  maxResultsMargin: s
}) => {
  const [v, B] = P(l || ""), [N, k] = P(!1), {
    isOpen: I,
    getMenuProps: $,
    getInputProps: F,
    getLabelProps: L,
    getItemProps: w,
    highlightedIndex: x,
    setInputValue: S
  } = D({
    items: a,
    initialInputValue: l,
    onInputValueChange: ({ inputValue: t }) => {
      const c = t || "";
      B(c), V?.(c);
    },
    itemToString: (t) => t?.value || "",
    onSelectedItemChange: ({ selectedItem: t }) => {
      t && y?.(t.value);
    }
  });
  T(() => {
    l !== void 0 && S(l);
  }, [l, S]), T(() => {
    if (v && a.length === 0) {
      k(!0);
      const t = setTimeout(() => {
        k(!1);
      }, 500);
      return () => clearTimeout(t);
    }
  }, [v, a]);
  const O = I && (a.length > 0 || N), q = G(
    () => a.map((t, c) => /* @__PURE__ */ i(
      "li",
      {
        className: r(h && e["item-block"], x === c && e.highlight),
        ...w({ item: t, index: c }),
        children: [
          h && /* @__PURE__ */ o(m, { name: h, size: "large" }),
          t.value
        ]
      },
      t.id
    )),
    [a, x, h, w]
  ), d = s ? {
    // 48px is the height of one suggestion
    mobile: s.mobile ? s.mobile * 48 : 0,
    desktop: s.desktop ? s.desktop * 48 : 0
  } : { mobile: 0, desktop: 0 };
  return /* @__PURE__ */ i(
    "div",
    {
      className: r(e["autocomplete-container"], j && e["full-width"]),
      style: d.mobile > 0 || d.desktop > 0 ? {
        "--margin-mobile": `${d.mobile}px`,
        "--margin-desktop": `${d.desktop}px`
      } : void 0,
      children: [
        /* @__PURE__ */ i("div", { className: e["input-container"], children: [
          u && /* @__PURE__ */ i(A, { children: [
            /* @__PURE__ */ o("label", { className: r(p && e["has-error"]), ...L(), children: u }),
            g && /* @__PURE__ */ o("div", { className: e["label-helper-text"], children: g })
          ] }),
          /* @__PURE__ */ i("div", { className: e["input-block"], children: [
            f && /* @__PURE__ */ o(m, { className: r(b && e.disabled), name: f, size: "large" }),
            /* @__PURE__ */ o(
              "input",
              {
                className: r(p && e["has-error"]),
                type: "text",
                ..._ && { placeholder: _ },
                ...F({ disabled: b })
              }
            )
          ] }),
          p && /* @__PURE__ */ i("div", { className: e["error-text"], children: [
            /* @__PURE__ */ o(m, { name: "error-warning-fill", size: "large", color: "error" }),
            C
          ] })
        ] }),
        /* @__PURE__ */ o(
          "div",
          {
            className: r(
              e["suggestions-container"],
              n && e["has-alternative-action"],
              !O && e.hidden
            ),
            children: /* @__PURE__ */ i("ul", { ...$(), children: [
              a.length > 0 ? q : N && /* @__PURE__ */ o("li", { className: e["no-suggestion"], children: z }),
              n && /* @__PURE__ */ o("li", { className: r(e["alternative-action-container"], n.href && e["has-href"]), children: /* @__PURE__ */ i("div", { className: e["alternative-action-container-wrapper"], children: [
                /* @__PURE__ */ o(m, { name: "pencil", size: "large", color: "secondary" }),
                /* @__PURE__ */ o(
                  J,
                  {
                    alternativeAction: n.text,
                    href: n.href,
                    openNewTab: n.openNewTab,
                    onAlternativeAction: n.action
                  }
                )
              ] }) })
            ] })
          }
        )
      ]
    }
  );
};
export {
  ee as Autocomplete
};
